package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowRight
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px

@Composable
fun CommonButton(
    text: String,
    onClick: () -> Unit,
    isCareerButton: Boolean = false,
    learnMore: Boolean = false,
    ratingSection: Boolean = false,
    isSendButton: Boolean = false,
    formIdToSubmit: String? = null,
    letsTalkButton: Boolean = false,
    blogButton: Boolean = false,
    isLoading: Boolean = false,
    progressIndicatorColor: com.varabyte.kobweb.compose.ui.graphics.Color.Rgb? = null
) {
    val sitePalette = ColorMode.current.toSitePalette()
    var isButtonHovered by remember { mutableStateOf(false) }
    val breakpoint = rememberBreakpoint()

    val buttonWidth = when {
        letsTalkButton && breakpoint < Breakpoint.MD -> 152.px
        isCareerButton || isSendButton -> 173.px
        blogButton -> 110.px
        else -> 170.px
    }

    val buttonHeight = if (letsTalkButton && breakpoint < Breakpoint.MD) 37.px else 40.px


    Box(
        modifier = Modifier
            .width(buttonWidth)
            .height(buttonHeight)
            .margin(top = if (learnMore && breakpoint < Breakpoint.MD) 30.px else 0.px)
            .onClick { onClick() }
            .cursor(Cursor.Pointer)
            .onMouseEnter { isButtonHovered = true }
            .onMouseLeave { isButtonHovered = false }
            .position(Position.Relative)
            .display(DisplayStyle.Flex)
            .justifyContent(JustifyContent.Center)
            .backgroundColor(if (isButtonHovered) Colors.White else sitePalette.commonSecondaryButtonColor.rgb)
            .styleModifier {
                property("background-color", "#254D79") // base color (blue)
                property("color", "white")
                property("align-items", "center")
            }
    ) {
        if (isLoading) {
            Box(
                modifier = Modifier.fillMaxWidth(),
                contentAlignment = Alignment.Center
            ) {
                ProgressIndicator(color = progressIndicatorColor)
            }
        } else {
            // Overlay Box like ::before
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .position(Position.Absolute)
                    .top(0.px)
                    .left(0.px)
                    .backgroundColor(if (isButtonHovered) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb)
                    .zIndex(0)
                    .styleModifier {
                        property("will-change", "clip-path")
                        property(
                            "transition",
                            "clip-path 0.2s ease-in-out, opacity 0.1s ease-in-out"
                        )
                        property("opacity", if (isButtonHovered) "1" else "0.999")
                        property(
                            "clip-path",
                            if (isButtonHovered)
                                "polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%)"
                            else
                                "polygon(98% 98%, 99% 98%, 99% 99%, 98% 99%)"
                        )
                    }
            )
            Box(
                modifier = Modifier
                    .size(12.px)
                    .position(Position.Absolute)
                    .bottom(0.px)
                    .right(0.px)
                    .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.primary.rgb)
                    .transform {
                        translateX(5.5.px)
                        translateY(5.px)
                    }
                    .zIndex(1)
                    .styleModifier {
                        property("opacity", if (isButtonHovered) "0" else "1")
                        property("transition", "opacity 0.1s ease")
//                    property("pointer-events", if (isButtonHovered) "none" else "auto")
                    }
            )
            SpanText(
                text,
                modifier = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (letsTalkButton && breakpoint < Breakpoint.MD) 16.px else 18.px)
                    .fontWeight(500)
                    .letterSpacing(0.5.px)
                    .color(if (isButtonHovered) sitePalette.bodyBackgroundSecondary.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                    .zIndex(1)
            )
        }
    }
}



@Composable
fun HoverButton(
    text: String,
    isHover: Boolean = true,
    onClick: () -> Unit,
    textColumnAlignment: Alignment.Horizontal = Alignment.CenterHorizontally,
) {
    var isButtonHovered = isHover
    val sitePalette = ColorMode.current.toSitePalette()
    Column {
        Box(
            modifier = Modifier.width(152.px)
                .height(43.px)
                .backgroundColor(if (isButtonHovered) sitePalette.commonSecondaryButtonColor.rgb else sitePalette.bodyBackgroundSecondary.rgb)
                .borderRadius(4.px, 18.px, 4.px, 23.px)
                .onMouseEnter { isButtonHovered = true }
                .onMouseLeave { isButtonHovered = false }
                .align(textColumnAlignment)
                .cursor(Cursor.Pointer),
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceEvenly
            ) {
                SpanText(
                    text,
                    modifier = Modifier.fontFamily(Constants.FONT_FAMILY)
                        .color(if (isButtonHovered) Colors.White else Colors.Black)
                )
                FaArrowRight(modifier = Modifier.color(if (isButtonHovered) Colors.White else Colors.Black))
            }
        }

    }
}